import React from 'react';
import { ExternalLink } from 'lucide-react';
interface ExperienceCardProps {
  role: string;
  company: string;
  period: string;
  description?: string;
  bullets: string[];
  takeaway?: string;
  isLast?: boolean;
  logoUrl?: string;
  portfolioUrl?: string;
  portfolioLabel?: string;
  videoUrl?: string;
}
export function ExperienceCard({
  role,
  company,
  period,
  description,
  bullets,
  takeaway,
  isLast,
  logoUrl,
  portfolioUrl,
  portfolioLabel = 'View Portfolio',
  videoUrl
}: ExperienceCardProps) {
  return <div className={`relative pb-10 ${isLast ? '' : 'mb-2'} print:pb-6 print:mb-0`} data-id="element-15">
      {/* Timeline line for desktop - hidden on print/mobile to save space/ink */}
      {!isLast && <div className="absolute left-[-24px] top-2 bottom-0 w-px bg-slate-200 hidden md:block print:hidden" data-id="element-16" />}

      <div className="flex flex-col md:flex-row md:items-start justify-between mb-3 gap-4" data-id="element-17">
        <div className="flex items-start gap-4 flex-1" data-id="element-18">
          {logoUrl && <div className="w-12 h-12 flex-shrink-0 rounded-lg overflow-hidden bg-white border border-slate-200 flex items-center justify-center print:border-black" data-id="element-19">
              <img src={logoUrl} alt={`${company} logo`} className="w-full h-full object-contain p-1" data-id="element-20" />
            </div>}
          <div className="flex flex-col" data-id="element-21">
            <h3 className="text-xl font-bold text-slate-900 print:text-black" data-id="element-22">
              {role}
            </h3>
            <div className="text-lg font-medium text-slate-700 print:text-black flex items-center gap-2" data-id="element-23">
              {company}
            </div>
          </div>
        </div>
        <span className="text-sm font-mono text-slate-500 print:text-black whitespace-nowrap md:mt-1" data-id="element-24">
          {period}
        </span>
      </div>

      {description && <div className="mb-4" data-id="element-25">
          <p className="text-slate-600 leading-relaxed max-w-3xl print:text-black" data-id="element-26">
            {description}
          </p>
          {portfolioUrl && <>
              <a href={portfolioUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 mt-2 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors print:hidden" data-id="element-27">
                {portfolioLabel}
                <ExternalLink className="w-3.5 h-3.5" data-id="element-28" />
              </a>
              <span className="hidden print:inline text-sm text-slate-600" data-id="element-29">
                {' '}
                Portfolio: {portfolioUrl}
              </span>
            </>}
        </div>}

      <ul className="space-y-2 mb-6" data-id="element-30">
        {bullets.map((bullet, idx) => <li key={idx} className="text-slate-600 leading-relaxed flex items-start gap-3 print:text-black" data-id="element-31">
            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-blue-600 flex-shrink-0 print:bg-black" data-id="element-32" />
            <span dangerouslySetInnerHTML={{
          __html: bullet
        }} data-id="element-33" />
          </li>)}
      </ul>

      {takeaway && <div className="bg-slate-50 border-l-2 border-blue-600 p-4 rounded-r-lg print:bg-transparent print:border-black print:p-0 print:pl-4 print:italic mb-6" data-id="element-34">
          <p className="text-sm text-slate-700 print:text-black" data-id="element-35">
            <span className="font-bold text-slate-900 mr-1 print:text-black" data-id="element-36">
              Key takeaway:
            </span>
            {takeaway}
          </p>
        </div>}

      {videoUrl && <div className="mt-6 print:hidden" data-id="element-37">
          <video src={videoUrl} autoPlay loop muted playsInline className="w-full rounded-lg border border-slate-200 shadow-sm" data-id="element-38" />
        </div>}
    </div>;
}